import './libs/foundation';


import Animate from './components/animate';
import BackTop from './components/back-top';
import BackgroundAnimate from './components/background-animate';
import Benefits from './components/benefits';
import Filters from './components/filters';
import HeroImageSlider from './components/hero-image-slider';
import Map from './components/map';
import MegamenuNav from './components/megamenu-nav';
import LoadMore from './components/load-more';
import Parallax from './components/parallax';
import Projects from './components/projects';
import RelatedArticles from './components/related-articles';
import SbsMediaHighlight from './components/sbs-media-highlight';
import SectorListing from './components/sector-listing';
import Share from './components/share';
import SlidingGallery from './components/sliding-gallery';
import Stats from './components/stats';
import TeamListing from './components/team-listing';
import Testimonials from './components/testimonials';
import Textarea from './components/textarea';
import Video from './components/video';

jQuery($ => {
    let animate = new Animate();
    let backTop = new BackTop();
    let backgroundAnimate = new BackgroundAnimate();
    let benefits = new Benefits();
    let heroImageSlider = new HeroImageSlider();
    let filters = new Filters();
    let map = new Map();
    let megamenuNav = new MegamenuNav();
    let loadMore = new LoadMore();
    let parallax = new Parallax();
    let projects = new Projects();
    let relatedArticles = new RelatedArticles();
    let sbsMediaHighlight = new SbsMediaHighlight();
    let sectorListing = new SectorListing();
    let share = new Share();
    let slidingGallery = new SlidingGallery();
    let stats = new Stats();
    let teamListing = new TeamListing();
    let testimonials = new Testimonials();
    let textarea = new Textarea();
    let video = new Video();
});
